import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page57() {
  useEffect(() => {
    document.title = "Маяк — Страница 56"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page55" />
        <ForwardLink href="/page57" />
      </div>

      <p style={{ textAlign: "right" }}>56.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Дай мне свой крюк, говорю<br/>
        ему, но бригадир Уинслоу, тот<br/>
        проклятый канадский сукин сын,<br/>
        тупой ублюдок... всегда называл<br/>
        меня псом. Грязным псом.
      </p>
      <p>СТАРИК поворачивается.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Уинслоу?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Да, тот ублюдок. “Я покажу тебе,<br/>
        кто здесь пес.”
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Уинслоу?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Что с ним?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        С кем, Уинслоу? Карнизы падают--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Он всегда бранится на меня, как<br/>
        и ты. Это просто чушь собачья.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Бранится?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Как ты вообще оказался на том<br/>
        травяном острове?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/><br/>
        Бранится? Кто бранится? Какой<br/>
        остров? В этом твоя проблема,<br/>
        Уинслоу.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Да, это проблема<br/>
        с Уинслоу.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        В этом твоя проблема!
      </p>
      <p>Пауза.</p>
      <p>МОЛОДОЙ делает глоток и смотрит СТАРИКУ в глаза.</p>
      <p style={{ textAlign: "right" }}>56.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page55" />
        <ForwardLink href="/page57" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629243/the-lighthouse-script/axsuo0e5oyqyyugx2i10.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page57;
